import { render, staticRenderFns } from "./VnpaySuccess.vue?vue&type=template&id=14daf558&"
import script from "./VnpaySuccess.vue?vue&type=script&lang=ts&"
export * from "./VnpaySuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports